<template>
  <div class="ml-3 ml-sm-0 mb-3 mb-sm-0">
    <div v-if="!checkIfMandateIsAbsent(mainMandate)">
      <appMultiselectOwners
        class="shadow-sm meeting-register-multipleselect-owners"
        :options="representativesToAdd"
        @onSelect="selectRepresentative"
        @onOpen="showSelect = true"
        @onClose="showSelect = false"
      />
    </div>
    <div v-if="checkIfMandateIsAbsent(mainMandate) && contact.is_selected">
      <appMultiselectOwners
        class="shadow-sm meeting-register-multipleselect-owners"
        :options="assignRepresentativesOptions"
        @onSelect="selectRepresentative"
        @onOpen="showSelect = true"
        @onClose="showSelect = false"
      />
    </div>
    <div v-if="addedRepresentatives.length > 0">
      <div v-for="option in addedRepresentatives" :key="option.id">
        <b-card
          v-if="mainMandate.representant_owner_id != option.id"
          no-body
          class="representative-card my-2 pl-2 py-2 pr-4 shadow-sm"
          :class="checkRepresentantStatus(option)"
        >
          <div class="d-flex align-items-center">
            <div>
              <b-form-checkbox
                v-if="!$_.isEmpty(mainMandate)"
                :value="1"
                :unchecked-value="0"
                :checked="isSelected(option.mandate_id)"
                :disabled="option.$isDisabled && !isSelected(option.mandate_id)"
                @change="toggleOption(option, $event)"
              />
              <b-form-checkbox
                v-else
                :value="1"
                :unchecked-value="0"
                :checked="isSelected(option.mandate_id)"
                @change="toggleOption(option, $event)"
              />
            </div>
            <div class="d-flex align-items-center">
              <appBOTantiemes :building-owner-data="option" />
              <span class="ml-2">
                {{ option.name }}
              </span>
            </div>
          </div>
          <div v-if="option.address" class="ml-4 pl-3">Address: {{ option.address }}</div>
          <font-awesome-icon
            class="icon-click color-gray-darker delete-mandate-button"
            icon="trash-alt"
            @click="removeRepresentative(option)"
          />
        </b-card>
      </div>
      <div>
        <div v-if="showOptimiser" class="text-center my-3">
          <div
            v-b-tooltip.hover
            class="btn"
            title="Algorithme pour déterminer et suggérer quel représentant la configuration vous donne le puissance maximum"
          >
            <font-awesome-icon icon="info-circle" size="1x" />
          </div>
          <div class="btn btn-simple bg-color-green-4 color-white" @click="getOptimised">
            Optimiser le puvoir
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appMultiselectOwners from "@/components/snippets/MultiselectOwners";

import MandateORM from "@/store/orm-axios/models/Mandate";
import MeetingORM from "@/store/orm-axios/models/Meeting";

import meetingDetailsMixin from "@/mixins/meeting-details";
import minutesMixin from "@/mixins/minutes";
import tablesMixins from "@/mixins/tables";
import meetingPresenceMixin from "@/mixins/meeting-presence";
import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";
import appBOTantiemes from "@/components/snippets/BuildingOwnerTantiemes";

import { votingLimitOperatorOptions } from "@/constants/building.js";

export default {
  components: {
    appMultiselectOwners,
    appBOTantiemes,
  },
  mixins: [
    meetingDetailsMixin,
    tablesMixins,
    meetingPresenceMixin,
    minutesMixin,
    meetingPresenceSelectOptionsMixins,
  ],
  props: {
    mainMandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isVideoCase: {
      type: Boolean,
      default: false,
    },
    isDummyVideoCase: {
      type: Boolean,
      default: false,
    },
    addedByQrCode: {
      type: String,
      default: null,
    },
    contact: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showSelect: false,
      addRepresentativesOptions: [],
      addedRepresentativesOptions: [],
      showModalsChangeMandateDates: {},
      showModalsAskMoveMandate: {},
      votingLimitOperatorOptions,
    };
  },
  computed: {
    meeting() {
      return MeetingORM.getters("getById")(this.$route.params.id);
    },
    representativesToAdd() {
      let addRepresentativesOptions = this.representativesNotDisabled();
      return this.$_.filter(addRepresentativesOptions, option => {
        let mandate = this.getMandate(option.mandate_id);
        return !mandate.is_selected && !mandate.representant_contact_id;
      });
    },
    addedRepresentatives() {
      return this.$_.filter(this.addRepresentativesOptions, option => {
        let mandate = this.getMandate(option.mandate_id);
        return mandate.is_selected;
      });
    },
    assignRepresentativesOptions() {
      return this.$_.filter(this.getBOsNotShowedUpOrRepresentedOpts(), option => {
        let mandate = this.getMandate(option.mandate_id);
        return !mandate.is_selected;
      });
    },
    showOptimiser() {
      let total = 0;
      let mainMandateTantiemes = this.getTotalMandateTantiemesChargeGenerale(this.mainMandate.id);
      total += mainMandateTantiemes;
      this.addedRepresentatives.forEach(element => {
        total += element.totalMandateTantiemesChargeGenerale;
      });
      if (
        total > this.votingLimitRules.tantiemesLimitPerMandate &&
        this.votingLimitRules.tantiemesLimitPerMandate &&
        this.votingLimitRules.tantiemesLimitPerMandate != 0
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    showSelect() {
      this.initRepresentativeOptions();
    },
    addedByQrCode(newValue) {
      if (newValue) {
        var addedMandate = MandateORM.query()
          .where("meeting_id", this.meeting.id)
          .where("building_owner_id", newValue)
          .first();

        if (!addedMandate) {
          return;
        }

        this.selectRepresentative(addedMandate.id);
        this.$emit("qrCodeAddedSuccesfully");
      }
    },
    mainMandate(newValue, oldValue) {
      if (newValue != oldValue) {
        this.initRepresentativeOptions();
      }
    },
  },
  created() {
    this.initRepresentativeOptions();
  },
  methods: {
    initRepresentativeOptions() {
      let opts = this.getBosCsSowedUpOrRepresentedAbsentOpts();
      opts = this.addRepresentativesOptions.length > 0 ? this.addRepresentativesOptions : opts;
      if (this.votingLimitRules.votingLimitIsActive) {
        this.addRepresentativesOptions = this.getBOsNotShowedUpOrRepresentedAbsentRestrictedOpts(
          opts,
          this.mainMandate.representant_owner_id || this.mainMandate.representant_contact_id
        );
      } else {
        this.addRepresentativesOptions = opts;
      }
    },
    async ADD_MANDATE(selectedOption) {
      try {
        var addedMandate = MandateORM.query()
          .where("meeting_id", this.mainMandate.meeting_id)
          .where("building_owner_id", selectedOption.id)
          .first();

        var self = this;
        MandateORM.update({
          where: addedMandate.id,
          data(item) {
            item.representant_contact_id = self.mainMandate.representant_contact_id;
            item.representant_owner_id = self.mainMandate.representant_owner_id;
            item.showed_up = 1;
            item.presence_status =
              self.isVideoCase || self.isDummyVideoCase
                ? self.mandatePresenceStatuses.pouvoir_by_video
                : self.mandatePresenceStatuses.pouvoir;
          },
        }).then(async updatedMandate => {
          await self.setMandateAddedEvent(updatedMandate.id, false);
          this.initRepresentativeOptions();
        });
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    async ASSIGN_MANDATE(selectedOption) {
      try {
        var assignedMandate = MandateORM.query()
          .where("meeting_id", this.meeting.id)
          .where("building_owner_id", selectedOption.id)
          .first();

        // TODO: ???: what shoud do here
        // if (assignedMandate.presence_status == this.mandatePresenceStatuses.correspondence) {
        //   await this.deleteVotesByCorrespondenceForResolutionsThatWereNotVoted(assignedMandate);
        // }

        var self = this;
        MandateORM.update({
          where: assignedMandate.id,
          data(item) {
            item.representant_contact_id = self.contact.id;
            item.representant_owner_id = null;
            item.presence_status = self.mandatePresenceStatuses.pouvoir;
          },
        }).then(async updatedMandate => {
          await self.setMandateAddedEvent(updatedMandate.id, false);
          this.initRepresentativeOptions();
        });
      } catch (err) {
        console.error(err);
        this.$swal(this.alertError());
      }
    },
    selectRepresentative(selectedOption) {
      let self = this;
      let mandateId = null;

      if (selectedOption.mandate_id) {
        mandateId = selectedOption.mandate_id;
      } else {
        mandateId = selectedOption;
      }

      let isDisabled = this.isDisabled(mandateId);
      if (isDisabled && !this.checkIfMandateIsAbsent(this.mainMandate)) {
        MandateORM.update({
          where: mandateId,
          data(item) {
            item.is_selected = true;
          },
        }).then(() => {
          this.initRepresentativeOptions();
        });
      } else if (!this.checkIfMandateIsAbsent(this.mainMandate)) {
        MandateORM.update({
          where: mandateId,
          data(item) {
            item.representant_contact_id = self.mainMandate.representant_contact_id;
            item.representant_owner_id = self.mainMandate.representant_owner_id;
            item.showed_up = 1;
            item.presence_status = self.mandatePresenceStatuses.pouvoir;
            item.is_selected = true;
          },
        }).then(async updatedMandate => {
          await self.setMandateAddedEvent(updatedMandate.id, false);
          this.initRepresentativeOptions();
        });
      } else if (this.contact && this.contact.is_selected) {
        MandateORM.update({
          where: mandateId,
          data(item) {
            item.representant_contact_id = self.contact.id;
            item.representant_owner_id = null;
            item.showed_up = 1;
            item.presence_status = self.mandatePresenceStatuses.pouvoir;
            item.is_selected = true;
          },
        }).then(async updatedMandate => {
          await self.setMandateAddedEvent(updatedMandate.id, false);
          this.initRepresentativeOptions();
        });
      }
    },
    // Trash icon
    removeRepresentative(selectedOption) {
      let mandate = this.getMandate(selectedOption.mandate_id);
      let mandateRemoved = { ...mandate };
      let contact_id = mandateRemoved.representant_contact_id;

      mandateRemoved.representant_contact_id = null;
      mandateRemoved.representant_owner_id = mandate.building_owner_id;
      mandateRemoved.showed_up = 0;
      mandateRemoved.presence_status = null;
      mandateRemoved.is_selected = false;
      MandateORM.update({
        where: mandateRemoved.id,
        data: mandateRemoved,
      });
      mandateRemoved = MandateORM.find(mandateRemoved.id);

      let minutes = this.changeMinutes(this.meeting, mandate, contact_id);
      MeetingORM.update({
        where: mandate.meeting_id,
        data(item) {
          item.minutes = minutes;
        },
      }).then(() => {
        this.initRepresentativeOptions();
      });
    },
    closeModalAskMoveMandate(mandateId) {
      this.$set(this.showModalsAskMoveMandate, mandateId, false);
    },
    closeModalChangeMandateDates(mandateId) {
      this.$set(this.showModalsChangeMandateDates, mandateId, false);
    },
    toggleOption(option, event) {
      if (this.contact && this.contact.is_selected) {
        if (event == 1) {
          this.ASSIGN_MANDATE(option);
        } else {
          this.removeMandate(option.mandate_id);
        }
      } else {
        if (event == 1) {
          this.ADD_MANDATE(option);
        } else {
          this.removeMandate(option.mandate_id);
        }
      }
    },
    // NOTE: This is a little bit similar with REMOVE_MANDATE from tables.js
    // Toggle checkbox
    removeMandate(mandateId) {
      let mandate = this.getMandate(mandateId);
      let mandateRemoved = { ...mandate };
      let contact_id = mandateRemoved.representant_contact_id;

      mandateRemoved.representant_contact_id = null;
      mandateRemoved.representant_owner_id = mandate.building_owner_id;
      mandateRemoved.showed_up = 0;
      mandateRemoved.presence_status = null;
      MandateORM.update({
        where: mandateRemoved.id,
        data: mandateRemoved,
      });
      mandateRemoved = MandateORM.find(mandateRemoved.id);
      let minutes = this.changeMinutes(this.meeting, mandate, contact_id);
      MeetingORM.update({
        where: mandate.meeting_id,
        data(item) {
          item.minutes = minutes;
        },
      }).then(() => {
        this.initRepresentativeOptions();
      });
    },
    isSelected(mandate_id) {
      let mandate = this.getMandate(mandate_id);
      if (!this.$_.isEmpty(this.contact)) {
        return this.contact.id == mandate.representant_contact_id ? 1 : 0;
      } else {
        return this.mainMandate.representant_owner_id == mandate.representant_owner_id ? 1 : 0;
      }
    },
    getMandate(mandateId) {
      return MandateORM.getters("getById")(mandateId) || {};
    },
    getOptimised() {
      let self = this;
      const getCombinations = arr =>
        arr.reduce((a, v) => a.concat(a.map(r => [v].concat(r))), [[]]);
      let combinations = getCombinations(this.addedRepresentatives);
      let allOptions = this.getNearestCombination(combinations);
      if (allOptions) {
        allOptions.forEach(option => {
          if (!this.$_.isEmpty(this.contact)) {
            MandateORM.update({
              where: option.mandate_id,
              data(item) {
                item.is_selected = true;
                item.showed_up = 1;
                item.presence_status = self.mandatePresenceStatuses.pouvoir;
                item.representant_owner_id = null;
                item.representant_contact_id = self.contact.id;
              },
            }).then(async updatedMandate => {
              await self.setMandateAddedEvent(updatedMandate.id, false);
            });
          } else {
            MandateORM.update({
              where: option.mandate_id,
              data(item) {
                item.is_selected = true;
                item.showed_up = 1;
                item.presence_status = self.mandatePresenceStatuses.pouvoir;
                item.representant_owner_id = self.mainMandate.representant_owner_id;
                item.representant_contact_id = null;
              },
            }).then(async updatedMandate => {
              await self.setMandateAddedEvent(updatedMandate.id, false);
            });
          }
        });
        this.initRepresentativeOptions();
      }
    },
    isOptionUnique(optimisedOptions, optionsArrayToCompare) {
      let isUnique = true;
      if (optimisedOptions.length > 0) {
        for (let i = 0; i < optimisedOptions.length; i++) {
          let areEqual = this.equalsIgnoreOrder(optimisedOptions[i].options, optionsArrayToCompare);
          if (areEqual) {
            isUnique = false;
          }
        }
      }

      return isUnique;
    },
    equalsIgnoreOrder(a, b) {
      if (a.length !== b.length) return false;
      const uniqueValues = new Set([...a, ...b]);
      for (const v of uniqueValues) {
        const aCount = a.filter(e => e === v).length;
        const bCount = b.filter(e => e === v).length;
        if (aCount !== bCount) return false;
      }
      return true;
    },
    uncheckAllOptions() {
      this.addedRepresentatives.forEach(option => {
        if (this.contact || option.mandate_id != this.mainMandate.id) {
          let mandate = this.getMandate(option.mandate_id);
          MandateORM.update({
            where: option.mandate_id,
            data(item) {
              item.representant_owner_id = null;
              item.representant_contact_id = null;
            },
          });
          let contact_id = this.contact ? this.contact.id : null;
          let minutes = this.changeMinutes(this.meeting, mandate, contact_id);
          MeetingORM.update({
            where: mandate.meeting_id,
            data(item) {
              item.minutes = minutes;
            },
          });
        }
      });
    },
    removeFromListAllOptions() {
      this.addedRepresentatives.forEach(option => {
        MandateORM.update({
          where: option.mandate_id,
          data(item) {
            item.is_selected = false;
          },
        });
      });
    },
    representativesNotDisabled() {
      let array = [];
      this.addRepresentativesOptions.forEach(element => {
        let item = { ...element };
        item.$isDisabled = false;
        array.push(item);
      });
      return array;
    },
    isDisabled(mandateId) {
      let found = this.$_.find(this.addRepresentativesOptions, item => {
        return item.mandate_id == mandateId;
      });
      if (found) {
        return found.$isDisabled;
      } else {
        return true;
      }
    },
    getNearestCombination(combinations) {
      let tantiemesLimitPerMandate = this.votingLimitRules.tantiemesLimitPerMandate;
      let mainMandateTantiemes = this.getTotalMandateTantiemesChargeGenerale(this.mainMandate.id);

      let tantiemesVotesLimit = tantiemesLimitPerMandate ? tantiemesLimitPerMandate : 0;
      if (mainMandateTantiemes && tantiemesLimitPerMandate) {
        tantiemesVotesLimit =
          tantiemesLimitPerMandate > mainMandateTantiemes
            ? tantiemesLimitPerMandate - mainMandateTantiemes
            : tantiemesLimitPerMandate;
      }

      this.uncheckAllOptions();

      let limitNrOfMandates = false;
      // NOTE: When votingLimitOperator = 1 (ET)
      if (this.votingLimitRules.votingLimitOperator == this.votingLimitOperatorOptions[0].value) {
        limitNrOfMandates = true;
      }

      let nearestCombinationIndex = null;
      let nearestCombinationValue = 0;
      combinations.forEach((combination, index) => {
        let localNearestCombinationValue = 0;
        if (
          !limitNrOfMandates ||
          (limitNrOfMandates && combination.length <= this.votingLimitRules.votesLimitPerMandate)
        ) {
          combination.forEach(object => {
            localNearestCombinationValue += object.totalMandateTantiemesChargeGenerale;
          });
          if (
            localNearestCombinationValue > nearestCombinationValue &&
            localNearestCombinationValue <= tantiemesVotesLimit
          ) {
            nearestCombinationValue = localNearestCombinationValue;
            nearestCombinationIndex = index;
          }
        }
      });
      return combinations[nearestCombinationIndex];
    },
    checkRepresentantStatus(option) {
      if (this.isSelected(option.mandate_id)) {
        return "selected";
      } else if (!this.isSelected(option.mandate_id) && option.$isDisabled) {
        return "disabled";
      } else {
        return "";
      }
    },
  },
};
</script>
